import { render } from "./SearchDropdown.vue?vue&type=template&id=06f16b94&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"

import "./SearchDropdown.vue?vue&type=style&index=0&id=06f16b94&scoped=true&lang=css"

import exportComponent from "/app/vendor/quizwhiz-legacy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f16b94"]])

export default __exports__